var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-43"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.9 284.3 287.4 284.3 282.43 241.94 311.94 241.94 316.9 284.3",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.09 284.3 288.24 284.3 283.27 241.94 315.12 241.94 320.09 284.3",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.84 280.27 287.06 239.67 313.63 239.67 318.41 280.27 291.84 280.27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.01 284.3 243.5 284.3 238.54 241.94 268.05 241.94 273.01 284.3",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.19 284.3 244.35 284.3 239.38 241.94 271.23 241.94 276.19 284.3",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.95 280.27 243.17 239.67 269.74 239.67 274.52 280.27 247.95 280.27",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.86,
    y: 284.39,
    width: 6.37,
    height: 98.01,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.81,
    y: 284.39,
    width: 4.42,
    height: 98.01,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.67,
    y: 284.39,
    width: 220.94,
    height: 10.82,
    transform: "translate(590.27 579.6) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.45,
    y: 295.21,
    width: 6.37,
    height: 87.19,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.4,
    y: 295.21,
    width: 4.42,
    height: 87.19,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.52,
    y: 295.21,
    width: 6.37,
    height: 87.19,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.48,
    y: 295.21,
    width: 4.42,
    height: 87.19,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.93,
    y: 295.21,
    width: 6.37,
    height: 87.19,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.89,
    y: 295.21,
    width: 4.42,
    height: 87.19,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.52,
    y: 284.39,
    width: 24.14,
    height: 10.82,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.34,270.55,87.4,256.29c.14,82.59.72,87.35.71,101.55h3.15C91.7,288.72,92.92,288.29,91.34,270.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9,382.45h0c14.69,0,27.09-8.8,30.11-20.68a49,49,0,0,1,3.14-9.25l.23-.48h-67l.23.48a48.27,48.27,0,0,1,3.14,9.25C62.8,373.65,75.2,382.45,89.9,382.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.28,355h67.24c1.87,0,3.5-1.86,4-4.53h0c.67-3.82-1.29-7.54-4-7.54H56.28c-2.68,0-4.64,3.72-4,7.54h0C52.77,353.16,54.41,355,56.28,355Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.24,284.49c3.63-14.41-16.95-29.86-41.65-45.72C58.74,281.48,86.55,338.79,100.24,284.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.43,302.62c-2.49-11.44-14.54-11-37.52-13.56C68,319.13,99.8,345.72,90.43,302.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.1,265c8.49-8.06-6.58-27-22.35-43.89C70.56,253.69,86.47,278.85,101.1,265Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.37,286.13c-3.16-11.52.85-35.85,33.88-37.59C114.89,281.55,101,339.66,86.37,286.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.61,310.56c1-13.56,11.45-29.62,45.63-18.07C116,318.79,83.2,343.24,85.61,310.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.12,301.39,445,291.06c-.1,59.82-.52,63.27-.51,73.56h-2.28C441.86,314.55,441,314.24,442.12,301.39Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.17,382.45h0c-10.65,0-19.63-6.37-21.82-15a35.27,35.27,0,0,0-2.27-6.7l-.17-.35h48.51l-.16.35a35.3,35.3,0,0,0-2.28,6.7C462.8,376.08,453.81,382.45,443.17,382.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.52,362.58H418.81c-1.35,0-2.53-1.35-2.87-3.28h0c-.48-2.77.93-5.46,2.87-5.46h48.71c1.94,0,3.36,2.69,2.88,5.46h0C470.06,361.23,468.88,362.58,467.52,362.58Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,318.66c-2.47-10.44,11.56-21.63,28.39-33.12C464.31,316.48,445.35,358,436,318.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.71,331.79c1.7-8.29,9.91-8,25.57-9.83C458,343.75,436.33,363,442.71,331.79Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.44,304.5c-5.78-5.84,4.48-19.54,15.23-31.79C456.25,296.34,445.41,314.57,435.44,304.5Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.48,319.85c2.15-8.35-.58-26-23.09-27.23C426,316.53,435.5,358.62,445.48,319.85Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,337.54c-.68-9.82-7.8-21.46-31.09-13.09C425.26,343.5,447.64,361.21,446,337.54Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-43"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-43",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--notice-board--inject-43"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.76,
    y: 65,
    width: 282.47,
    height: 160.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.24,230.76v-1a4.6,4.6,0,0,0,4.59-4.6h1A5.6,5.6,0,0,1,391.24,230.76Zm-181.74,0H188.05v-1H209.5ZM396.83,77.83h-1v-5.5h1Zm0-9.39h-1V65a4.6,4.6,0,0,0-4.59-4.6H376.33v-1h14.91a5.6,5.6,0,0,1,5.59,5.6Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.24,227.26H108.76a2.1,2.1,0,0,1-2.09-2.1V65a2.1,2.1,0,0,1,2.09-2.1H391.24a2.1,2.1,0,0,1,2.09,2.1V225.16A2.1,2.1,0,0,1,391.24,227.26Zm-280.38-4.19H389.14V67.1H110.86Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "287.86 96.85 293.58 196.08 278.35 205.76 218.52 209.21 212.29 101.2 287.86 96.85",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.84 198.18 278.35 205.76 293.58 196.08 279.84 198.18",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.37,
    cy: 138.84,
    r: 28.99,
    transform: "translate(-34.69 115.09) rotate(-24.09)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.14,
    y: 176.42,
    width: 57.99,
    height: 20.51,
    transform: "translate(-10.32 14.99) rotate(-3.3)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.92,
    y: 185.17,
    width: 29.44,
    height: 1.8,
    transform: "translate(-10.27 15.6) rotate(-3.3)",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.92,
    y: 186.75,
    width: 16.64,
    height: 1.8,
    transform: "translate(-10.41 14.02) rotate(-3.3)",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.24,
    y: 192.1,
    width: 37.2,
    height: 1.8,
    transform: "translate(-10.7 14.64) rotate(-3.3)",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.71,
    y: 190.52,
    width: 8.97,
    height: 1.8,
    transform: "translate(562.95 366.63) rotate(176.7)",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.55,
    y: 179.83,
    width: 50.48,
    height: 1.8,
    transform: "translate(-9.98 14.96) rotate(-3.3)",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.78,136.83a1,1,0,0,0,1.08,1l4.46-.25a1.21,1.21,0,0,1,1.29,1.14l.13,2.22a1.23,1.23,0,0,1-1.15,1.29l-4.46.25a1,1,0,0,0,.12,2.06l4.1-.24a1.22,1.22,0,0,1,1.25,1.54,8,8,0,0,1-7.19,5.8l-2.59.15a8,8,0,0,1-7.81-4.94,1.23,1.23,0,0,1,1.07-1.67l4.93-.28a1,1,0,0,0-.11-2.06l-5.31.31a1.22,1.22,0,0,1-1.28-1.15l-.13-2.22a1.21,1.21,0,0,1,1.15-1.28l5.3-.31a1,1,0,0,0-.12-2.05l-5.3.31a1.23,1.23,0,0,1-1.29-1.15l-.13-2.22a1.22,1.22,0,0,1,1.15-1.28l5.3-.31a1,1,0,0,0-.12-2l-4.93.29a1.23,1.23,0,0,1-1.25-1.54,8,8,0,0,1,7.18-5.81l2.6-.15a8,8,0,0,1,7.8,4.94,1.23,1.23,0,0,1-1.07,1.68l-4.09.23a1,1,0,1,0,.11,2.05l4.47-.25a1.21,1.21,0,0,1,1.28,1.14l.13,2.22a1.22,1.22,0,0,1-1.14,1.29l-4.47.25A1,1,0,0,0,254.78,136.83Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.35,160.58a16.75,16.75,0,0,1-16.7-15.77,2.1,2.1,0,0,1,4.19-.25,12.56,12.56,0,0,0,13.24,11.8l2.6-.15A12.55,12.55,0,0,0,266.48,143a2.1,2.1,0,0,1,4.19-.24,16.76,16.76,0,0,1-15.75,17.67l-2.6.15Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.18,172.39a2.1,2.1,0,0,1-2.09-2l-.68-11.91a2.09,2.09,0,1,1,4.18-.24l.69,11.91a2.1,2.1,0,0,1-2,2.22Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.17,
    y: 98.69,
    width: 108.18,
    height: 75.7,
    transform: "translate(16.7 291.18) rotate(-85.35)",
    style: {
      fill: "#F15E22",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.8,
    y: 98.54,
    width: 80.24,
    height: 59.93,
    transform: "translate(25.3 284.45) rotate(-85.35)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.88,100.15l-7.06-6.52a1.06,1.06,0,0,0-1.69.37l-2.33,5.52,0,.09-3.83,9.07c-.07-.08-.12-.16-.2-.24a7.72,7.72,0,0,0-3.6-1.92c-3.2-.77-6.11.32-6.64,2.5s1.56,4.48,4.76,5.26a8.35,8.35,0,0,0,1.82.24c2.33.06,4.24-.92,4.76-2.56h0l4.3-10.18,5.95,5.5a1.07,1.07,0,0,0,.94.25,1,1,0,0,0,.75-.62l2.35-5.56A1.06,1.06,0,0,0,202.88,100.15Zm-3.45,4.54-5.41-5,1.47-3.49,5.41,5Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.77,166.66l5.08-24.77L188.29,130a2.12,2.12,0,0,0-1-2.27l-25.75-15a2.13,2.13,0,0,0-3.16,1.41l-6.44,31.4a14.94,14.94,0,0,0-8.36-2.72c-6.62-.27-11.95,3-12.13,7.55-.1,2.31,1.22,4.55,3.61,6.15.33.22.68.42,1,.62a16.06,16.06,0,0,0,6.82,1.74,15.58,15.58,0,0,0,8-1.71,7.31,7.31,0,0,0,4-5.39.58.58,0,0,0,.05-.11l4.48-21.86,21.87,12.79-3.69,18c-.17-.13-.3-.27-.48-.39a15.46,15.46,0,0,0-7.87-2.36c-6.62-.27-12,3-12.14,7.54-.11,2.76,1.73,5.22,4.69,6.78a16,16,0,0,0,6.79,1.74,15.46,15.46,0,0,0,8-1.72,7.29,7.29,0,0,0,4-5.38S180.76,166.7,180.77,166.66ZM160.4,125.34l1.54-7.51,21.88,12.78-1.54,7.52Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.63,102.14l4-6.76,1.93-3.25a.68.68,0,0,0-.07-.77l-6-7a.64.64,0,0,0-.56-.23.68.68,0,0,0-.51.32L162.3,93a4.71,4.71,0,0,0-2.18-1.64c-1.92-.75-3.82-.32-4.33,1a2.26,2.26,0,0,0,.44,2.18,3.07,3.07,0,0,0,.24.29A4.94,4.94,0,0,0,158.3,96a4.76,4.76,0,0,0,2.54.31,2.25,2.25,0,0,0,1.72-1.17s0,0,0,0l3.54-6,5.13,6L168.33,100a.86.86,0,0,0-.1-.16,4.84,4.84,0,0,0-2.07-1.5c-1.92-.75-3.82-.32-4.33,1a2.38,2.38,0,0,0,.69,2.47,4.93,4.93,0,0,0,1.82,1.19,4.87,4.87,0,0,0,2.54.32,2.28,2.28,0,0,0,1.72-1.18Zm-1.8-14.2,1.22-2,5.13,6-1.22,2Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.56,
    y: 152.43,
    width: 2.66,
    height: 51.17,
    transform: "translate(-27.75 325.93) rotate(-85.35)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.11,
    y: 157.93,
    width: 2.66,
    height: 51.17,
    transform: "translate(-33.64 330.55) rotate(-85.35)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.3,
    y: 101.04,
    width: 108.18,
    height: 75.7,
    transform: "translate(184.97 471.49) rotate(-87.35)",
    style: {
      fill: "#F15E22",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.05,
    y: 123.71,
    width: 67.3,
    height: 59.93,
    transform: "translate(169.54 484.92) rotate(-87.35)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.83,
    cy: 151,
    r: 22.31,
    transform: "translate(-13.3 267.67) rotate(-42.35)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.88,128.35A22.67,22.67,0,1,0,361.48,152,22.7,22.7,0,0,0,339.88,128.35Zm-7.12,42.59-2.3-8.37,3.46-4.33h0l9.06.42h0l3,4.63L343,171.41ZM352,147.68a.33.33,0,0,0,0,.1l-5.73,1.57-6.8-5.43.28-6.14,7.36-4.84,8,6.42Zm-19.69-15.42,6.87,5.5-.28,6.13-7.27,4.78L326,146.58s0-.07,0-.1l-2.36-8.57ZM325.66,147l5.56,2.1s0,.06,0,.1l2.35,8.54-3.46,4.33,0,0-8.88-.41-2.72-9.91Zm29.75,16.23-8.88-.41h0l-3-4.63,3.12-8.29s0-.07,0-.1l5.73-1.57,6.72,5.37ZM357.2,139l-1.67-.08h0l-8.14-6.51h0l-.5-1.85A22.06,22.06,0,0,1,357.2,139Zm-24.5-9.1-.68,1.8h0l-8.7,5.73h0l-1.68-.07A22.1,22.1,0,0,1,332.7,129.93Zm-14.82,21.92h0l2.76,10v0l-.32.85a21.85,21.85,0,0,1-3.44-11.71Zm19.93,21.06a21.92,21.92,0,0,1-5.7-1l.55-.36a0,0,0,0,1,0,0l10.4.48h0l.51.41A21.66,21.66,0,0,1,337.81,172.91Zm18.35-8.49-.24-.87s0,0,0,0l3.68-9.74h0l1.07-.7A21.77,21.77,0,0,1,356.16,164.42Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.7,
    y: 72.41,
    width: 22.75,
    height: 59.93,
    transform: "translate(223.05 438.35) rotate(-87.35)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.69,100.35h0a1.3,1.3,0,0,1-1.35,1.24L324,100a1.31,1.31,0,0,1-1.24-1.36h0a1.3,1.3,0,0,1,1.36-1.23L358.46,99A1.29,1.29,0,0,1,359.69,100.35Z",
    style: {
      fill: "#F15E22",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.42,106.1h0a1.29,1.29,0,0,1-1.35,1.24l-34.38-1.59a1.3,1.3,0,0,1-1.23-1.36h0a1.29,1.29,0,0,1,1.35-1.23l34.38,1.59A1.29,1.29,0,0,1,359.42,106.1Z",
    style: {
      fill: "#F15E22",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.86,
    y: 80.85,
    width: 21.88,
    height: 5.2,
    transform: "translate(-23.18 92.66) rotate(-34.68)",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.19,
    y: 85.03,
    width: 21.88,
    height: 5.2,
    transform: "translate(4.88 190.89) rotate(-34.68)",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.18,
    y: 187.48,
    width: 21.88,
    height: 5.2,
    transform: "translate(-73.31 145.36) rotate(-34.68)",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.22,
    y: 187.81,
    width: 21.88,
    height: 5.2,
    transform: "translate(-42.58 244.45) rotate(-34.68)",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.33,
    y: 98.41,
    width: 23.18,
    height: 5.2,
    transform: "translate(96.17 -133.89) rotate(31.95)",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.76,
    y: 201.82,
    width: 23.18,
    height: 5.2,
    transform: "translate(141.87 -86.7) rotate(31.95)",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.71,
    y: 88.27,
    width: 23.18,
    height: 5.2,
    transform: "translate(104.8 -184.32) rotate(31.95)",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.05,
    y: 125.37,
    width: 106.3,
    height: 20.74,
    transform: "translate(-43.06 89.12) rotate(-26.57)",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.05,
    y: 125.37,
    width: 106.3,
    height: 20.74,
    transform: "translate(-43.06 89.12) rotate(-26.57)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.4,154.68l2.87-.49a5.12,5.12,0,0,1,.09,2.15,3.89,3.89,0,0,1-.81,1.73,5.63,5.63,0,0,1-1.86,1.38,6.67,6.67,0,0,1-2.67.79,4.37,4.37,0,0,1-2.42-.71,5.86,5.86,0,0,1-2.09-2.47,5.27,5.27,0,0,1-.54-4.12,5.15,5.15,0,0,1,2.82-2.95,5.29,5.29,0,0,1,3.09-.67,4.66,4.66,0,0,1,2.56,1.43l-2.23,1.81a3,3,0,0,0-.59-.48,2,2,0,0,0-.83-.21,1.8,1.8,0,0,0-.86.22,1.86,1.86,0,0,0-1.1,1.51,3.77,3.77,0,0,0,.52,2,3.9,3.9,0,0,0,1.51,1.87,2,2,0,0,0,2.6-1.16A3.1,3.1,0,0,0,131.4,154.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.07,152.16l-3.23,1.62.31,1.74L136.24,157,135.1,146l3.1-1.55,8.07,7.48-3,1.49Zm-1.59-1.7-2.67-2.8.65,3.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.59,142.29l2.66-1.33,6,3.36-2.55-5.1,2.69-1.34,4.61,9.21-2.69,1.34-6-3.33,2.53,5.06-2.68,1.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.15,139.31l2.87-.5a5.11,5.11,0,0,1,.08,2.15,3.77,3.77,0,0,1-.81,1.74,5.7,5.7,0,0,1-1.86,1.38,6.67,6.67,0,0,1-2.67.79,4.43,4.43,0,0,1-2.41-.72,5.74,5.74,0,0,1-2.1-2.47,5.35,5.35,0,0,1-.54-4.12,6.18,6.18,0,0,1,5.91-3.61,4.66,4.66,0,0,1,2.57,1.42L161,137.19a2.36,2.36,0,0,0-.58-.48,1.8,1.8,0,0,0-.84-.21,1.91,1.91,0,0,0-.86.21,1.84,1.84,0,0,0-1.09,1.52,3.68,3.68,0,0,0,.51,2,3.9,3.9,0,0,0,1.52,1.87,2.06,2.06,0,0,0,2.6-1.17A3.28,3.28,0,0,0,162.15,139.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.29,131.93l7.63-3.82,1,2-4.78,2.39.73,1.46,4.43-2.21.94,1.88-4.43,2.21.91,1.82,4.92-2.46,1,2.09-7.77,3.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.6,127.28l2.84-1.42,3.48,6.94,4.44-2.22,1.13,2.27-7.29,3.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.18,123l2.85-1.43,3.47,6.95,4.44-2.23,1.14,2.27-7.29,3.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.76,118.7l7.63-3.82,1,2-4.77,2.39.73,1.46,4.43-2.22.94,1.88-4.43,2.22.91,1.82,4.91-2.46,1,2.08-7.76,3.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.1,114l4.23-2.12a5.56,5.56,0,0,1,2.19-.67,3.65,3.65,0,0,1,1.76.34,4.4,4.4,0,0,1,1.46,1.11,7.28,7.28,0,0,1,1.12,1.67,6.9,6.9,0,0,1,.81,2.46,4.14,4.14,0,0,1-.25,1.83,3.29,3.29,0,0,1-.92,1.37,7.16,7.16,0,0,1-1.57,1.1l-4.23,2.12Zm3.89.66,2.51,5,.7-.35a3.07,3.07,0,0,0,1.17-.83,1.5,1.5,0,0,0,.25-1,4.74,4.74,0,0,0-.59-1.7,3.47,3.47,0,0,0-1.48-1.77,2.25,2.25,0,0,0-1.85.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.35,
    y: 162.05,
    width: 106.3,
    height: 20.74,
    transform: "translate(34.54 -41.52) rotate(10.22)",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.35,
    y: 162.05,
    width: 106.3,
    height: 20.74,
    transform: "translate(34.54 -41.52) rotate(10.22)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.48,166.16l2.6,1.32a5,5,0,0,1-1.22,1.77,3.82,3.82,0,0,1-1.69.91,5.77,5.77,0,0,1-2.31,0,6.62,6.62,0,0,1-2.62-1,4.36,4.36,0,0,1-1.5-2,5.79,5.79,0,0,1-.2-3.23,5.33,5.33,0,0,1,2-3.62,5.16,5.16,0,0,1,4-.67,5.23,5.23,0,0,1,2.87,1.31,4.6,4.6,0,0,1,1.2,2.68l-2.87.11a2.37,2.37,0,0,0-.19-.73,1.86,1.86,0,0,0-.54-.67,2,2,0,0,0-.81-.35,1.88,1.88,0,0,0-1.79.57,3.67,3.67,0,0,0-.79,1.92,3.83,3.83,0,0,0,.1,2.4,1.75,1.75,0,0,0,1.32.88,1.77,1.77,0,0,0,1.45-.26A3.12,3.12,0,0,0,209.48,166.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.54,170.52l-3.56-.64-.8,1.59-3.2-.58,5.64-9.45,3.42.62,2,10.82-3.28-.59Zm-.26-2.3-.46-3.85-1.77,3.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.86,162.93l2.93.52,2.81,6.3,1-5.61,2.95.53-1.83,10.14-2.95-.53L228,168l-1,5.56-2.94-.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.31,172.25l2.6,1.33a5.24,5.24,0,0,1-1.22,1.77,3.71,3.71,0,0,1-1.69.9,5.43,5.43,0,0,1-2.31,0,6.72,6.72,0,0,1-2.62-1,4.36,4.36,0,0,1-1.5-2,5.8,5.8,0,0,1-.2-3.23,5.36,5.36,0,0,1,2-3.63,6.17,6.17,0,0,1,6.9.65,4.6,4.6,0,0,1,1.2,2.67l-2.88.12a2.33,2.33,0,0,0-.18-.73,1.78,1.78,0,0,0-.54-.67,2,2,0,0,0-2.6.21,3.75,3.75,0,0,0-.79,1.92,3.91,3.91,0,0,0,.09,2.4,1.79,1.79,0,0,0,1.33.89,1.77,1.77,0,0,0,1.45-.26A3.1,3.1,0,0,0,243.31,172.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.65,167l8.4,1.52-.4,2.16-5.25-1-.29,1.61,4.87.88-.37,2.07-4.87-.88-.36,2,5.4,1-.41,2.3-8.55-1.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.88,168.88l3.14.56-1.38,7.64,4.89.88-.45,2.5-8-1.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.33,170.58l3.13.56-1.37,7.65,4.88.88-.45,2.49-8-1.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.77,172.28l8.39,1.51-.39,2.17-5.25-1-.29,1.61,4.87.88-.37,2.07-4.87-.88-.36,2,5.4,1-.41,2.3-8.55-1.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.05,174.13l4.65.84a5.48,5.48,0,0,1,2.15.78,3.64,3.64,0,0,1,1.21,1.32,4.33,4.33,0,0,1,.51,1.77,7.62,7.62,0,0,1-.1,2,6.88,6.88,0,0,1-.83,2.45,4.2,4.2,0,0,1-1.3,1.32,3.38,3.38,0,0,1-1.55.55,7.46,7.46,0,0,1-1.92-.06l-4.65-.84Zm2.71,2.86-1,5.54.76.14a3.18,3.18,0,0,0,1.44,0,1.53,1.53,0,0,0,.79-.64,5,5,0,0,0,.55-1.72,3.49,3.49,0,0,0-.13-2.3,2.26,2.26,0,0,0-1.63-.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.42,
    y: 134.71,
    width: 106.3,
    height: 20.74,
    transform: "translate(73.37 -109.4) rotate(20.81)",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.42,
    y: 134.71,
    width: 106.3,
    height: 20.74,
    transform: "translate(73.37 -109.4) rotate(20.81)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.39,131.57l2.31,1.78a5.14,5.14,0,0,1-1.53,1.52,3.83,3.83,0,0,1-1.82.58,5.7,5.7,0,0,1-2.27-.44,6.63,6.63,0,0,1-2.4-1.43,4.42,4.42,0,0,1-1.1-2.26,5.83,5.83,0,0,1,.39-3.21,5.34,5.34,0,0,1,2.67-3.19,5.13,5.13,0,0,1,4.08.08,5.26,5.26,0,0,1,2.58,1.82,4.63,4.63,0,0,1,.69,2.85l-2.85-.41a2.45,2.45,0,0,0,0-.76,1.83,1.83,0,0,0-.41-.75,1.94,1.94,0,0,0-.74-.5,1.87,1.87,0,0,0-1.86.23,3.68,3.68,0,0,0-1.13,1.74,3.93,3.93,0,0,0-.35,2.38,1.8,1.8,0,0,0,1.14,1.11,1.77,1.77,0,0,0,1.48,0A3.16,3.16,0,0,0,296.39,131.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.47,137.71l-3.38-1.28L301,137.84l-3-1.15,7.28-8.26,3.24,1.24,0,11-3.11-1.18Zm.17-2.31.25-3.87-2.36,3.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.09,131.41l2.77,1.05,1.61,6.71,2-5.33,2.8,1.07-3.66,9.63-2.8-1.07-1.6-6.66-2,5.29L309.43,141Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.52,143.78l2.31,1.78a5.14,5.14,0,0,1-1.53,1.52,3.83,3.83,0,0,1-1.82.58,5.7,5.7,0,0,1-2.27-.44,6.63,6.63,0,0,1-2.4-1.43,4.42,4.42,0,0,1-1.1-2.26,5.83,5.83,0,0,1,.39-3.21,5.37,5.37,0,0,1,2.67-3.19,5.17,5.17,0,0,1,4.08.08,5.12,5.12,0,0,1,2.58,1.83,4.58,4.58,0,0,1,.69,2.84l-2.85-.41a2.45,2.45,0,0,0,0-.76,2,2,0,0,0-3-1,3.76,3.76,0,0,0-1.13,1.74,3.93,3.93,0,0,0-.35,2.38,1.8,1.8,0,0,0,1.14,1.11,1.77,1.77,0,0,0,1.48,0A3.08,3.08,0,0,0,328.52,143.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.73,139.63l8,3-.78,2.06-5-1.9-.58,1.53,4.63,1.76-.75,2-4.63-1.76-.72,1.89,5.14,2-.83,2.18-8.12-3.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.45,143.33l3,1.13-2.75,7.26,4.64,1.76-.9,2.37L340.79,153Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.42,146.74l3,1.13-2.76,7.26,4.64,1.76-.9,2.37-7.62-2.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.39,150.15l8,3-.78,2-5-1.9-.59,1.53,4.64,1.76-.75,2-4.63-1.76-.72,1.9,5.13,2-.83,2.18-8.11-3.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.15,153.85l4.42,1.68a5.72,5.72,0,0,1,2,1.16,3.72,3.72,0,0,1,.95,1.53,4.44,4.44,0,0,1,.17,1.83,7.29,7.29,0,0,1-.47,1.95,6.81,6.81,0,0,1-1.26,2.26,4.32,4.32,0,0,1-1.52,1.06,3.38,3.38,0,0,1-1.63.25,6.89,6.89,0,0,1-1.87-.41l-4.42-1.68Zm2.14,3.32-2,5.26.73.27a3.21,3.21,0,0,0,1.41.3,1.51,1.51,0,0,0,.89-.49,4.67,4.67,0,0,0,.86-1.58,3.54,3.54,0,0,0,.3-2.29,2.25,2.25,0,0,0-1.45-1.19Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.8,145.09c1.11,5.67,2.22,16.07-1.75,19.85a42.22,42.22,0,0,1,19.47,10.75c4-7.4-1.83-10.75-1.83-10.75-6.33-1.51-6.17-6.2-5.07-10.61Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.2,170.8c-1.29-6.11,3-7-4-10-5.46-2.36-15.94-2.62-18.48-.68-1.41,1.09.33,4.86.33,4.86Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.51,175.93c-.49.77-1.08,1.77-1.63,2.68s-1.1,1.88-1.63,2.84c-1.06,1.92-2.13,3.84-3.11,5.81-2,3.91-3.85,7.9-5.46,12-.41,1-.81,2-1.17,3.06L90,203.81s-.09,0-.11.18a4.32,4.32,0,0,0,.13,1.73,16.72,16.72,0,0,0,.85,2.53,71.22,71.22,0,0,0,6.42,11l.07.11a2.95,2.95,0,0,1-4.15,4c-1.06-.76-2-1.5-2.91-2.31s-1.84-1.61-2.71-2.49a37,37,0,0,1-4.88-5.89,21,21,0,0,1-2-3.74,14.64,14.64,0,0,1-1.19-5,11.28,11.28,0,0,1,.35-3.23l.48-1.76c.31-1.18.66-2.33,1-3.49a108.31,108.31,0,0,1,5.31-13.45c1-2.17,2.12-4.32,3.31-6.42.59-1,1.19-2.09,1.82-3.13s1.25-2,2-3.17a5.87,5.87,0,0,1,9.83,6.42Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.94,221.52l-1.33-.85-3.79-2.46L93,222.32c.89,4,4.86,5.89,4.86,5.89l1.52.34a2.22,2.22,0,0,0,2.62-1.43l.48-1.18A3.81,3.81,0,0,0,100.94,221.52Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.73,165.84c-4.9,2.07-9.17,7.21-13.42,17.48,1.13,4.23,13.91,11.16,13.91,11.16S114.39,160.74,97.73,165.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.88,178.32c-.16,3.81,5.87,12.64-1.57,17.76-.88,7.71-2,15.3-4,27.95H97.45c4.14-14,1.25-23.4-3.89-48a9.82,9.82,0,0,1,8.62-11.77c1.55-.15,3.19-.28,4.87-.37a123.43,123.43,0,0,1,17.64,0c1.9.17,3.87.41,5.75.67A13.33,13.33,0,0,1,141.88,178.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.48,139.86c-.15.75.13,1.45.63,1.54s1-.43,1.16-1.19-.13-1.45-.62-1.54S133.63,139.1,133.48,139.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.42,138.66l1.92-.16S135.13,139.73,134.42,138.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.64,140.7a20.47,20.47,0,0,0,1.73,5.36,3.28,3.28,0,0,1-2.79,0Z",
    style: {
      fill: "#630f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,136.07a.39.39,0,0,0,.32-.12.46.46,0,0,0,0-.64,4.52,4.52,0,0,0-3.86-1.48.46.46,0,0,0-.37.53.47.47,0,0,0,.53.37,3.54,3.54,0,0,1,3,1.2A.43.43,0,0,0,136,136.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,132.41c-1.29,9.4-2,13.36,1.62,19,5.5,8.55,17.11,8,21.12-.83,3.62-8,5.12-22-3.07-27.46S110.26,123,109,132.41Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.73,139.1c-3.71,6-.94,13.92,6.65,15.42-11.11,8-34.89,6.47-37.61.92-5.14-10.5-1.33-27.73,8.09-34.45s23.44-6.33,31.48,9.51C134.48,132.75,131.63,137.44,127.73,139.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,140.9c.74,2.36,1,3.37,2.42,4.32a2.79,2.79,0,0,0,4.49-2.48c-.08-2.27-1.29-5.74-3.66-6.15S122.23,138.54,123,140.9Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.28,224s.07,50.87-3.79,83.17c-.61,30.33-4.06,101.15-4.06,101.15h-7.66s-11.88-60.36-8.14-96.27c-15.58-51.3-5.34-88-5.34-88Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.48,406a1.05,1.05,0,0,1,1.14.26,20.47,20.47,0,0,0,11,7.2c4.83,1.46,2.85,3.86-4.39,3-8.51-1.06-10.76.19-13.61.19s-4.37-2.58-2.73-8.19a1,1,0,0,1,.87-.72A34.35,34.35,0,0,0,128.48,406Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.13,224s-15.88,59.34-24.89,87c-9.45,29-18.32,95.18-18.34,97.37H76.28s-6.84-53.64,5.15-97.4c3.24-71,16-86.92,16-86.92Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.15,406a.83.83,0,0,1,1,.26c1.64,2.22,1.25,5.12,7.32,7.2,4.25,1.46,2.2,3.86-4.31,3-7.66-1.06-7.8.19-10.4.19S73,414,75.1,408.39a1.13,1.13,0,0,1,.87-.72A31.38,31.38,0,0,0,83.15,406Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.2,318.34c-.1,3.42-.21,7.07-.35,10.87a118.57,118.57,0,0,1-19.9-5.85c.07-3.26.24-6.43.5-9.43A102.37,102.37,0,0,0,132.2,318.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82,300.12a157.46,157.46,0,0,0,19.55,9.79c-.12.36-.23.72-.35,1.07-.68,2.08-1.35,4.36-2,6.79a174.72,174.72,0,0,1-17.63-9.94Q81.79,303.86,82,300.12Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M136.28,224s.87,39.91-2.12,99.94C106.05,321.83,78.73,304,78.73,304s.82-63.36,18.72-80C107.56,221.33,136.08,223.12,136.28,224Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.81,171.31c.95,1.31,1.76,2.5,2.56,3.77s1.6,2.51,2.37,3.78q2.3,3.84,4.34,7.82c1.37,2.65,2.62,5.39,3.78,8.18a91,91,0,0,1,3.07,8.64l.12.42a4.72,4.72,0,0,1-.68,4.08c-1.19,1.66-2.45,3.27-3.79,4.8a59.82,59.82,0,0,1-4.19,4.38,59.1,59.1,0,0,1-4.59,3.93c-.79.62-1.63,1.19-2.46,1.77s-1.66,1.09-2.65,1.65a2.93,2.93,0,0,1-3.7-4.42l.16-.19,1.69-2c.57-.7,1.12-1.43,1.68-2.14,1.1-1.44,2.19-2.89,3.22-4.37s2-3,3-4.47,1.83-3.05,2.7-4.57l-.56,4.5c-1-2.48-2-4.94-3.22-7.4s-2.47-4.87-3.82-7.28-2.75-4.79-4.19-7.15-3-4.75-4.41-6.93l-.08-.13a5.87,5.87,0,0,1,9.68-6.63Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.2,225.35l-1.48-2.74-2.3-4.32-2.85.75a4.36,4.36,0,0,0-3.12,5.31,10.77,10.77,0,0,0,1.4,3.16l2,1.85a1.92,1.92,0,0,0,2.15.29l3.34-1.69A1.91,1.91,0,0,0,141.2,225.35Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.71,165.45c5.19,1.17,10.79,4.49,14.93,14.33-.36,4.36-11.66,14-11.66,14S116.41,163.42,133.71,165.45Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418,146.15l.81,1,.71.94c.47.62.9,1.25,1.33,1.88.88,1.24,1.67,2.53,2.47,3.8,1.56,2.58,3,5.22,4.34,8,.66,1.35,1.29,2.75,1.9,4.14s1.16,2.84,1.67,4.3a73.36,73.36,0,0,1,2.67,9l.23.92a7,7,0,0,1,.14,2.45A34.56,34.56,0,0,1,431,193.17a42.65,42.65,0,0,1-2.35,4.34c-.83,1.38-1.68,2.7-2.59,4a72.25,72.25,0,0,1-5.82,7.09c-1,1.1-2.09,2.16-3.17,3.21s-2.19,2-3.46,3a5.28,5.28,0,0,1-8.1-6.38l.16-.34,1.74-3.57c.61-1.2,1.18-2.42,1.74-3.62,1.13-2.41,2.21-4.79,3.12-7.16a54.86,54.86,0,0,0,2.3-6.87,19.78,19.78,0,0,0,.75-5.68l.36,3.37c-.9-2.21-1.86-4.4-3-6.6s-2.26-4.37-3.52-6.53-2.54-4.32-3.9-6.43l-2-3.14L401.34,159l-.36-.53a10.49,10.49,0,0,1,17-12.28Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,146.15l.81,1,.71.94c.47.62.9,1.25,1.33,1.88.88,1.24,1.67,2.53,2.47,3.8,1.56,2.58,3,5.22,4.34,8,.66,1.35,1.29,2.75,1.9,4.14s1.16,2.84,1.67,4.3a73.36,73.36,0,0,1,2.67,9l.23.92a7,7,0,0,1,.14,2.45A34.56,34.56,0,0,1,431,193.17a42.65,42.65,0,0,1-2.35,4.34c-.83,1.38-1.68,2.7-2.59,4a72.25,72.25,0,0,1-5.82,7.09c-1,1.1-2.09,2.16-3.17,3.21s-2.19,2-3.46,3a5.28,5.28,0,0,1-8.1-6.38l.16-.34,1.74-3.57c.61-1.2,1.18-2.42,1.74-3.62,1.13-2.41,2.21-4.79,3.12-7.16a54.86,54.86,0,0,0,2.3-6.87,19.78,19.78,0,0,0,.75-5.68l.36,3.37c-.9-2.21-1.86-4.4-3-6.6s-2.26-4.37-3.52-6.53-2.54-4.32-3.9-6.43l-2-3.14L401.34,159l-.36-.53a10.49,10.49,0,0,1,17-12.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.14,413.15s10.22-3.75,11.55-6.26h8.86l-.54,9.35h-7.23l-.8-.86-1.42.86c-4.42,0-8.49-.17-11.21-1.17A2.19,2.19,0,0,1,391.14,413.15Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.08,310.35c-1.24-41.07,1.94-68.52-1.86-88.76l-35.53-.53s9.38,65.17,14,92.3,10.89,94.13,10.89,94.13h11.66S420.69,342.12,414.08,310.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.12,251.44c1.89,5.87,2.71,43.54.63,62.35,0-.14-.05-.29-.07-.43-1.62-9.53-3.83-23.77-6-38.23Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.18,405s16.24,1.52,18.15-.48l8.4,2.83-3,8.87-5.17-1.75-.53-1.08-1.58.37c-4.18-1.41-15.25-5.32-17.57-7.16A2,2,0,0,1,326.18,405Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.82,309.08c17-38.17,25.09-87.67,25.09-87.67L365.09,216s-5.87,66.18-9.09,93.79c-3.37,28.71-12.94,95-12.94,95l12.06,4.07S379.22,342.78,378.82,309.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.53,118.83c-1.14,9,1.34,14.61,3.45,20-3.68,3.42-9.65,7.67-17.6,7.55s-6.5-5.49-4.37-8.26c5.7-2.88,5.91-7.51,4.52-10.07Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.79,128.62a6.35,6.35,0,0,1,.14,4.37c2.5-.27,5.09-1.44,6.05-2.93C387.52,129.68,385.3,128.84,383.79,128.62Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.4,140.64s-4.83-4.25-6.83-5.25-17.42-.66-21,0-7.94,6-7.94,6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.75,109.65c-.1.73-.57,1.26-1.05,1.19s-.78-.71-.68-1.44.56-1.27,1-1.2S375.84,108.92,375.75,109.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.08,105.27a.42.42,0,0,0,.4-.1,3.41,3.41,0,0,1,3-.91A.42.42,0,0,0,379,104a.44.44,0,0,0-.31-.53,4.28,4.28,0,0,0-3.78,1.11.44.44,0,0,0,0,.61A.39.39,0,0,0,375.08,105.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.71,111.46c-2,8.82-2.81,14.1-8.08,17.87-7.94,5.68-18.26-.36-18.88-9.65-.57-8.35,2.89-21.38,12.22-23.37A12.48,12.48,0,0,1,400.71,111.46Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.67,119.11a7.82,7.82,0,0,1,1.21.58.23.23,0,0,1,.07.32.27.27,0,0,1-.34.08,6.78,6.78,0,0,0-5.84-.54.24.24,0,0,1-.32-.11.25.25,0,0,1,.13-.31A7.22,7.22,0,0,1,381.67,119.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.22,116.43a18.07,18.07,0,0,1-4.33-4.34s1.75-5.52,4.33-6.81c-3.41-.86-6.56-3-6.33-5.53-7.08.92-9.78.25-11-3.08s2.44-6.34,7.35-7,7.09,2.58,7.09,2.58a14.71,14.71,0,0,1,9.67-.42c5,1.67,2.49,6.34,2.49,6.34s5.09-2.58,6.92,4.83-4.83,7.88-4.83,7.88,2.83.89,1.83,5.55a5.37,5.37,0,0,1-5.58,4.33S394.39,131.18,394.22,116.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.89,111c-.1.73-.56,1.27-1,1.2s-.79-.72-.69-1.45.57-1.26,1-1.2S382,110.27,381.89,111Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.32,104.55a.44.44,0,0,0,.28.3,3.41,3.41,0,0,1,2.22,2.18.42.42,0,0,0,.52.31.43.43,0,0,0,.32-.52,4.23,4.23,0,0,0-2.78-2.79.43.43,0,0,0-.55.27A.43.43,0,0,0,381.32,104.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,110.67s-2.23,4-4.33,5.74c1.13,1.4,3.4,1.16,3.4,1.16Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.93,117.57a7.63,7.63,0,0,1-4.63,3.14c-2.39.46-3.12-1.94-2.07-4.27.95-2.1,3.33-4.87,5.54-4.27S399.35,115.53,397.93,117.57Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,139.65a147.79,147.79,0,0,0-32.48-.32,18.94,18.94,0,0,0-16.77,17c-1.69,18.18-.38,46.88,2.74,75.69,27.32,9.17,54-.4,54-.4.6-6.29-1.69-26.61-3.8-37.61,1.55-11.36,5.49-24.36,7.71-39.44A13.12,13.12,0,0,0,408,139.65Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.47,167.39l-8.14,1-2.25-9.67s7.59-2.73,12.28,3.19Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.82,166l5.51,2.33-2.25-9.67-4.24,0a1.15,1.15,0,0,0-1.12,1.45l1.44,5.19A1.12,1.12,0,0,0,303.82,166Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.82,158.87l-1.36,2c-.44.63-.9,1.24-1.34,1.86-.9,1.23-1.85,2.4-2.81,3.58a91.19,91.19,0,0,1-6.17,6.78c-1.11,1.09-2.23,2.16-3.41,3.22s-2.42,2.06-3.71,3.05a50.79,50.79,0,0,1-8.62,5.47l-.93.47a8,8,0,0,1-5.69.55,66.41,66.41,0,0,1-8.51-3.08c-2.67-1.14-5.19-2.47-7.67-3.8s-4.84-2.82-7.16-4.37a80.72,80.72,0,0,1-6.79-5,5.32,5.32,0,0,1,4.58-9.28l.22.05c2.5.58,5.08,1.31,7.59,2s5,1.35,7.49,2,4.92,1.22,7.3,1.77,4.72.92,6.86,1.21l-6.62,1a48.85,48.85,0,0,0,5-4.23c1.67-1.64,3.33-3.43,5-5.29s3.25-3.82,4.82-5.82l2.36-3,2.2-2.88.34-.46a10.5,10.5,0,0,1,17.07,12.2Z",
    style: {
      fill: "#F15E22"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/Cancelled.a8ef6ac1399461d785916e18201b8bb1.svg";
export { ForwardRef as ReactComponent };